import { registerPackageResources } from "@inbody/core";
import en from "./en.json.js";
import ko from "./ko.json.js";
const namespace = "ui";
const uiResources = {
  ko: {
    [namespace]: ko
  },
  en: {
    [namespace]: en
  }
};
registerPackageResources({
  namespace,
  resources: uiResources
});
export {
  uiResources
};
